import { ASSETS } from "@/lib/constants";

export default function SectionLabel({ number, children, align = "left" }) {
  // `number` prop is intentionally ignored — section enumerations were
  // removed per producer direction. Prop kept for backward compatibility.
  void number;
  const alignClass =
    align === "center"
      ? "justify-center"
      : align === "right"
      ? "justify-end"
      : "";
  return (
    <div className={`flex ${alignClass} mb-6`}>
      <span className="inline-flex items-center gap-4 sm:gap-5">
        <img
          src={ASSETS.trophyMark}
          alt=""
          aria-hidden="true"
          className="h-14 sm:h-16 w-auto object-contain shrink-0 [filter:drop-shadow(0_3px_12px_rgba(214,163,41,0.4))]"
          loading="lazy"
        />
        <span className="font-bebas text-[26px] sm:text-[28px] tracking-[0.28em] uppercase text-gold whitespace-nowrap leading-none">
          {children}
        </span>
        <span
          aria-hidden="true"
          className="block w-12 sm:w-16 h-px bg-[color:var(--gold-deep)] shrink-0"
        />
      </span>
    </div>
  );
}
